import { render, staticRenderFns } from "./editBar.vue?vue&type=template&id=0fb58e3f&scoped=true&"
import script from "./editBar.vue?vue&type=script&lang=js&"
export * from "./editBar.vue?vue&type=script&lang=js&"
import style0 from "./editBar.vue?vue&type=style&index=0&id=0fb58e3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb58e3f",
  null
  
)

export default component.exports